(function () {
  var KEY = 'mirrorless.size';
  var DAYS_MIN = 3, DAYS_MAX = 5; // delivery window shown on the page, in business days (US only)
  var NOT_SOLD = 'globo-out-of-stock';

  function q(s, r) { return (r || document).querySelector(s); }
  function qa(s, r) { return [].slice.call((r || document).querySelectorAll(s)); }

  // ---------- the size picker (Globo swatches) ----------
  function sizeList() { return q('.product-info .globo-swatch-list') || q('.globo-swatch-list'); }
  function options() { var l = sizeList(); return l ? qa('li.select-option', l) : []; }
  function checkedOption() { var l = sizeList(), c = l && q('input:checked', l); return c ? c.closest('li') : null; }
  function labelOf(li) { return li ? (li.getAttribute('data-value') || '') : ''; }
  function isOut(li) { return !!li && li.classList.contains(NOT_SOLD); }
  function store(label) { if (!label) return; try { localStorage.setItem(KEY, label); } catch (e) {} }

  // The size a shopper picks (or adds to the cart) is remembered on this device, so next time that size is preselected
  document.addEventListener('change', function (e) {
    if (!e.isTrusted || !e.target.matches || !e.target.matches('.globo-swatch-list input')) return;
    var li = e.target.closest('li');
    if (li && !isOut(li)) store(labelOf(li));
  }, true);

  document.addEventListener('click', function (e) {
    var t = e.target.closest && e.target.closest('.product-info buy-buttons button[type="submit"], product-sticky-bar buy-buttons button[type="submit"]');
    if (!t) return;
    var li = checkedOption();
    if (li && !isOut(li)) store(labelOf(li));
  }, true);

  // ---------- "Find my size" link in the size picker's heading ----------
  function findSizeLink() {
    var lg = q('.product-info .globo-swatch-list .name-option');
    if (!lg || q('.cb-findsize', lg)) return;
    var b = document.createElement('button');
    b.type = 'button';
    b.className = 'cb-findsize';
    b.setAttribute('data-size-quiz-open', '');
    b.textContent = 'Find my size';
    lg.appendChild(b);
  }

  // ---------- phone sticky bar: size chips + Buy now ----------
  function stickyBar() {
    var bar = q('product-sticky-bar');
    if (!bar) return;

    var row = q('.cb-sizes', bar);
    if (!row) {
      row = document.createElement('div');
      row.className = 'cb-sizes';
      row.setAttribute('role', 'radiogroup');
      row.setAttribute('aria-label', 'Size');
      bar.insertBefore(row, bar.firstChild);
    }

    var items = options();
    var sig = items.map(function (li) { return labelOf(li) + (isOut(li) ? '!' : ''); }).join('|');
    if (row.getAttribute('data-sig') !== sig) {
      row.innerHTML = '';
      items.forEach(function (li) {
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'cb-chip' + (isOut(li) ? ' is-out' : '');
        b.setAttribute('role', 'radio');
        b.setAttribute('data-label', labelOf(li));
        b.textContent = labelOf(li).replace(' - ', ' / ');
        row.appendChild(b);
      });
      row.setAttribute('data-sig', sig);
      row.removeAttribute('data-shown');
    }

    var cur = labelOf(checkedOption()), on = null;
    qa('.cb-chip', row).forEach(function (b) {
      var is = b.getAttribute('data-label') === cur;
      b.classList.toggle('is-on', is);
      b.setAttribute('aria-checked', is ? 'true' : 'false');
      if (is) on = b;
    });
    if (on && row.getAttribute('data-shown') !== cur && row.clientWidth) {
      row.setAttribute('data-shown', cur);
      row.scrollLeft = on.offsetLeft - (row.clientWidth - on.offsetWidth) / 2;
    }

    var bb = q('buy-buttons', bar);
    if (!bb) return;
    var atc = q('button[type="submit"]', bb), now = q('.cb-buynow', bb);
    if (!now) {
      now = document.createElement('button');
      now.type = 'button';
      now.className = 'cb-buynow';
      now.textContent = 'Buy now';
      bb.appendChild(now);
    }
    now.hidden = !!(atc && atc.disabled);
  }

  function buyNow(btn) {
    var li = checkedOption();
    var id = li && li.getAttribute('data-variantid');
    if (!id || isOut(li)) return;
    var label = labelOf(li), old = btn.textContent;
    btn.disabled = true;
    btn.textContent = 'One sec...';
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: Number(id), quantity: 1 })
    }).then(function (r) {
      if (!r.ok) throw new Error('add');
      store(label);
      window.location.href = '/checkout';
    }).catch(function () {
      btn.disabled = false;
      btn.textContent = old;
      var a = q('product-sticky-bar buy-buttons button[type="submit"]');
      if (a) a.click();
    });
  }

  // ---------- delivery estimate ----------
  // US shoppers get an arrival window. Everyone else gets the "Ships worldwide" wording from the data-intl attributes
  // (no dates: international delivery time depends on the country).
  function addBusinessDays(d, n) {
    var x = new Date(d.getTime());
    while (n > 0) {
      x.setDate(x.getDate() + 1);
      var w = x.getDay();
      if (w !== 0 && w !== 6) n--;
    }
    return x;
  }

  function delivery() {
    var p = q('[data-cb-delivery]');
    if (!p || p.getAttribute('data-done')) return;
    p.setAttribute('data-done', '1');
    var dates = q('[data-cb-dates]', p), sub = q('.cb-delivery__sub', p);
    var country = '';
    try { country = (window.Shopify && window.Shopify.country) || ''; } catch (e) {}

    function international() {
      if (dates) {
        dates.textContent = dates.getAttribute('data-intl') || '';
        dates.hidden = !dates.textContent;
      }
      if (sub && sub.getAttribute('data-intl')) sub.textContent = sub.getAttribute('data-intl');
    }

    if (country && country !== 'US') { international(); return; }
    try {
      var parts = new Intl.DateTimeFormat('en-US', { timeZone: 'America/Chicago', year: 'numeric', month: 'numeric', day: 'numeric' }).formatToParts(new Date());
      var v = {};
      parts.forEach(function (x) { v[x.type] = Number(x.value); });
      var start = new Date(v.year, v.month - 1, v.day);
      if (start.getDay() === 6) start.setDate(start.getDate() + 2);
      else if (start.getDay() === 0) start.setDate(start.getDate() + 1);
      var f = new Intl.DateTimeFormat('en-US', { weekday: 'short', month: 'short', day: 'numeric' });
      dates.textContent = 'Arrives ' + f.format(addBusinessDays(start, DAYS_MIN)) + ' - ' + f.format(addBusinessDays(start, DAYS_MAX));
    } catch (e) {
      international();
    }
  }

  // ---------- share with a parent ----------
  function share(btn) {
    var li = checkedOption();
    var id = li && li.getAttribute('data-variantid');
    var label = labelOf(li);
    var url = location.origin + location.pathname + (id ? '?variant=' + id : '');
    var text = 'Can I get these? 323 Cleats' + (label ? ', size ' + label.replace(' - ', ' / ') : '') + '.';

    if (navigator.share) {
      navigator.share({ title: '323 Cleats', text: text, url: url }).catch(function () {});
      return;
    }
    var span = q('[data-cb-share-label]', btn);
    var copied = navigator.clipboard && navigator.clipboard.writeText
      ? navigator.clipboard.writeText(text + ' ' + url)
      : Promise.reject();
    copied.then(function () {
      if (!span) return;
      var old = span.textContent;
      span.textContent = 'Link copied';
      setTimeout(function () { span.textContent = old; }, 2000);
    }).catch(function () {
      window.location.href = 'mailto:?subject=' + encodeURIComponent('323 Cleats') + '&body=' + encodeURIComponent(text + '\n\n' + url);
    });
  }

  // ---------- clicks ----------
  document.addEventListener('click', function (e) {
    var chip = e.target.closest && e.target.closest('.cb-chip');
    if (chip) {
      var want = chip.getAttribute('data-label');
      var li = options().filter(function (l) { return labelOf(l) === want; })[0];
      if (li) {
        var lb = q('label', li);
        if (lb) lb.click();
        if (!isOut(li)) store(want);
        schedule();
      }
      return;
    }
    var now = e.target.closest && e.target.closest('.cb-buynow');
    if (now) { buyNow(now); return; }
    var sh = e.target.closest && e.target.closest('[data-cb-share]');
    if (sh) share(sh);
  });

  var pending = false;
  function schedule() {
    if (pending) return;
    pending = true;
    setTimeout(function () {
      pending = false;
      findSizeLink();
      stickyBar();
      delivery();
    }, 30);
  }

  new MutationObserver(schedule).observe(document.body, { childList: true, subtree: true });
  document.addEventListener('change', function () { setTimeout(schedule, 80); }, true);
  window.addEventListener('load', schedule);
  window.addEventListener('pageshow', schedule);
  schedule();
})();